import * as React from 'react'
import * as classnames from 'classnames'

import * as styles from './vertiefungBox.css'

import { StoreComponent, injectStores } from '../../../store'
import { observable, runInAction } from 'mobx'
import { observer } from 'mobx-react'
import { Portal } from 'react-portal'
import { TextOverlay } from '../book/overlays/textOverlay'
import { DocumentOverlay } from '../book/overlays/documentOverlay'
import { ContentSubTopic, ContentRef } from '../storydocStoreContent'
import { VideoOverlay } from '../book/overlays/videoOverlay'

const Hypher = require('hypher')
const german = require('hyphenation.de')
const h = new Hypher(german)

// returns ['hy', 'phen', 'ation']

const typeButtonsDesktop = {
  Document: require('./modal-btn-document.svg'),
  Picture: require('./modal-btn-document.svg'),
  Text: require('./modal-btn-text.svg'),
  Video: require('./modal-btn-video.svg')
}

const typeButtonsMobile = {
  Document: require('./mobile-modal-btn-document.svg'),
  Picture: require('./mobile-modal-btn-document.svg'),
  Text: require('./mobile-modal-btn-text.svg'),
  Video: require('./mobile-modal-btn-video.svg')
}

interface IProps {
  chapterId?: string
  vertiefung: ContentRef<ContentSubTopic>
  active?: boolean
  openBox?: boolean
  size: number
  onExpandClick? (): void
}

@injectStores
@observer
export class VertiefungBox extends StoreComponent<IProps> {
  @observable expanded = this.props.openBox && this.props.active
  @observable.ref vertiefung: ContentSubTopic | null = null
  titleCharLimit = 50
  @observable buttonHover = false

  onCloseClick = () => {
    this.expanded = !this.expanded
    this.props.onExpandClick && this.props.onExpandClick()
    if (this.vertiefung && this.vertiefung.subcontentType === 'Video') this.store.storeCommon.currentStory.paused = !this.store.storeCommon.currentStory.paused
    this.buttonHover = false
  }

  element: HTMLDivElement | null = null

  constructor (props: any, context: any) {
    super(props, context)
    this.fetchSubTopic()
  }

  async fetchSubTopic () {
    const topic = await this.store.storyDocContent.getSubContent(this.props.vertiefung)
    runInAction(() => {
      this.vertiefung = topic
    })
  }

  render () {
    let closed: JSX.Element | null = null
    let overlay: JSX.Element | null = null
    const dots = '...'

    if (this.expanded && this.store.storeCommon.currentStory.vertiefungExpanded) {
      if (this.vertiefung) {
        if (this.vertiefung.subcontentType === 'Text') {
          overlay = <Portal><TextOverlay onCloseClick={this.onCloseClick} content={this.vertiefung} open={this.expanded}/></Portal>
        } else if (this.vertiefung.subcontentType === 'Document' || this.vertiefung.subcontentType === 'Picture') {
          overlay = <Portal><DocumentOverlay onCloseClick={this.onCloseClick} content={this.vertiefung} open={this.expanded}/></Portal>
        } else if (this.vertiefung.subcontentType === 'Video') {
          overlay = <Portal>
                      <div onClick={(e: any) => {
                        e.stopPropagation()
                      }}>
                      <VideoOverlay onCloseClick={this.onCloseClick} content={this.vertiefung} open={this.expanded}/>
                      </div>
                    </Portal>
        }
      }
    } else {
      let description: JSX.Element | null = null
      if (this.vertiefung && this.vertiefung.excerpt) {
        description = <div className={styles.description}>{this.vertiefung.excerpt.replace(/\s/g, ' ')}</div>
      }

      let title: JSX.Element | null = null
      if (this.vertiefung && this.vertiefung.title) {
        let titleText = this.vertiefung.title
        if (this.store.breakpoints.phone && this.vertiefung.title.length > this.titleCharLimit) {
          titleText = h.hyphenateText(this.vertiefung.title).substring(0, this.titleCharLimit) + dots
        } else {
          if (!titleText.includes('Pleven') && !titleText.includes('Bundeswehr')) {
            titleText = h.hyphenateText(this.vertiefung.title)
          }
        }
        title = <div className={styles.title}>
                  {titleText}
                </div>
      }

      let image: JSX.Element | null = null
      if (this.vertiefung) {
        image = <div className={styles.image}
                   style={{
                     backgroundImage: `url(${this.vertiefung.urlTNImage})`
                   }} />
      }

      let typeButton: JSX.Element | null = null
      if (this.vertiefung) {
        if (this.store.breakpoints.desktop) {
          typeButton = <div className={classnames(styles.typeButton, this.buttonHover ? styles.typeButtonScaleup : styles.typeButtonScaledown)} onMouseEnter={() => this.buttonHover = true} onMouseLeave={() => this.buttonHover = false}>
                        <img src={typeButtonsDesktop[this.vertiefung.subcontentType]} alt='vertiefung_type_btn'/>
                      </div>
        } else {
          typeButton = <div className={styles.typeButton}>
                        <img src={typeButtonsMobile[this.vertiefung.subcontentType]} alt='vertiefung_type_btn'/>
                      </div>
        }
      }

      closed = (
          <div className={styles.headerbox} onClick={this.onCloseClick}>
            <div className={styles.left} style={this.store.breakpoints.desktop ? { width: `${this.props.size}px` } : undefined}>
              {image}
              {typeButton}
            </div>
            <div className={styles.right} >
              {title}
              {this.store.breakpoints.desktop && this.props.size === 150 && description}
            </div>
          </div>
        )
    }

    // height is hardcoded to handle small screens rendering
    return (
        <div
          className={ styles.box }
          ref={ elem => this.element = elem }
          style={ this.store.breakpoints.desktop ?
            { height: `${ this.props.size }px` } :
            { width: `${ this.store.storeCommon.window.width > 180 * 2 ? 20 + this.store.storeCommon.window.width / 2 : 180 }px` }}
          >
          { closed }
          { overlay }
        </div>
    )
    // }
  }
}



// WEBPACK FOOTER //
// ./src/modules/storydoc/vertiefungBox/vertiefungBox.tsx